module.exports = __webpack_public_path__ + "img/gantt.ede69a8a.png";